import * as axios from "./Axios";

/**
 * Kiosk Analytics
 *
 * POST admin/kiosk-analytics
 * Body: { startDate: "YYYY-MM-DD", endDate: "YYYY-MM-DD", companyId?: number }
 *
 * Expected response (either at the root or wrapped in `data`):
 * {
 *   kpis: {
 *     sessions, selfServiceBookings, videoCalls, completed,
 *     activeKiosks, totalKiosks, revenue
 *   },
 *   daily: [
 *     { date: "YYYY-MM-DD", sessions, selfServiceBookings, videoCalls, completed }
 *   ],
 *   kiosks: [
 *     {
 *       id, name, venue, company,
 *       sessions, selfServiceBookings, videoCalls, completed, revenue,
 *       lastActiveAt: ISO-8601 | null, isActive: boolean
 *     }
 *   ]
 * }
 *
 * See change-logs/2026-10-28-kiosk-analytics-screen.md for the full contract.
 */
export const getKioskAnalytics = (data) =>
  axios.post("admin/kiosk-analytics", data);
